import { useTranslation } from "react-i18next";
import { Check, Play } from "lucide-react";

import BaseBadge from "@/components_v2/Badge/BaseBadge";
import BaseButton from "@/components_v2/Button/BaseButton";
import {
  BUTTON_SIZES,
  BUTTON_VARIANTS,
} from "@/components_v2/Button/constants";

import { EventCardProps } from "../types";

const EventCard = ({
  month,
  day,
  title,
  description,
  isCompleted,
  linkUrl,
}: EventCardProps) => {
  const { t } = useTranslation();
  const hasLink = linkUrl != null && linkUrl !== "";

  return (
    <div className="guidance-page-event-card flex gap-300">
      <div className="flex flex-col items-center">
        <span className="guidance-page-event-card-month-text body-m-regular">
          {month}
        </span>

        <span className="guidance-page-event-card-day-text header-l-medium">
          {day}
        </span>
      </div>

      <div className="guidance-page-event-card-content flex flex-col gap-200 flex-1">
        <div className="flex items-center gap-200 flex-wrap">
          <h3 className="guidance-page-event-card-title body-m-medium">
            {title}
          </h3>

          {isCompleted && (
            <BaseBadge
              children={t("labels.complete")}
              backgroundColor="var(--green-700-10)"
              fontColor="var(--green-700)"
              leadingIcon={<Check size={16} />}
            />
          )}
        </div>

        <p className="guidance-page-section-description body-m-regular">
          {description}
        </p>

        {hasLink && (
          <BaseButton
            variant={
              isCompleted ? BUTTON_VARIANTS.TERTIARY : BUTTON_VARIANTS.PRIMARY
            }
            size={BUTTON_SIZES.SMALL}
            leadingIcon={isCompleted ? <Play size={16} /> : undefined}
            onClick={() =>
              window.open(linkUrl, "_blank", "noopener,noreferrer")
            }
          >
            {isCompleted ? t("labels.viewRecording") : t("labels.registerNow")}
          </BaseButton>
        )}
      </div>
    </div>
  );
};

export default EventCard;
